import React from 'react';
import moment from 'moment';
import {Link} from 'react-router';
import ClientLogo from './ClientLogo';
import StaffMemberAssignedText from './StaffMemberAssignedText';

export default class ClientPreview extends React.Component {
    static defeaultProps = {
      showLogo: true
    };
    render() {
        var {client} = this.props;

        var signedUpDateString = client.signedUpAt ? moment(client.signedUpAt).format('MMMM Do YYYY') : "Hasn't signed up";

        console.log('client', client);
        if(! client.status) {
            var labelClassName = "";
        } else {
            var labelClassName = client.status.includes('Customer') ? "label label-success" : "label label-info";
        }

        var assignedUserId = client.assignedUserIds && client.assignedUserIds.length ? client.assignedUserIds[0] : null;
        var staffNumbers = client.activeUsers ? client.activeUsers.length : 0;
        return (
            <div className="panel-body">
                <div className="row">
                    {this.props.showImage &&
                        <div className="col-md-4">
                            <div style={{height: '95px'}}>
                                <ClientLogo client={client}/>
                            </div>
                        </div>
                    }
                    <div className={this.props.showImage ? "col-md-8": ""}>
                        <div>
                            <div className="pull-right">
                                {client.id == this.props.onPageClientId && <span className="label label-warning" style={{marginRight: '5px'}}>Client on page</span>}
                                <span className={labelClassName}>{client.status}</span>
                                { client.fergusId &&
                                <span className="label label-danger">Has Fergus Account</span>
                                }
                            </div>
                            <Link to={`/clients/${client.id}`}><h2 style={{marginTop: '0px', fontWeight: 'bold'}}><span className="clientId">#{client.publicId}</span>  {client.name}</h2></Link>
                        </div>

                        <div>
                            <div style={{float: 'left', marginRight: '15px'}}>
                                <i className="fa fa-calendar"></i> {signedUpDateString}
                            </div>
                            <div>
                                <i className="fa fa-user"></i>
                                <StaffMemberAssignedText assignedStaffMember={this.props.staff.find(u => u.id == assignedUserId)} />
                            </div>
                        </div>
                        {client.address &&
                            <div className="row">
                                <i style={{marginLeft: '17px'}} className="fa fa-map-marker"></i> <span style={{marginLeft: '2px'}}>{client.address}</span>
                            </div>
                        }
                        <div className="row" style={{marginTop: '10px'}}>
                            <div className="col-xs-4">
                                <div><strong>{client.score ? client.score : "N/A"}</strong></div>
                                <div><small>Score</small></div>
                            </div>
                            <div className="col-xs-4">
                                <div>
                                    <strong>
                                        {client.cmrr ? client.cmrr : "N/A"}
                                    </strong>
                                </div>
                                <div>
                                    <small>CMRR</small>
                                </div>
                            </div>
                            <div className="col-xs-4">
                                <div><strong>{staffNumbers}</strong></div>
                                <div><small>Users</small></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/ClientPreview.js